import { useEffect, useState } from 'react';
import useDebounce from '@/hooks/useDebounce';
import { FiSearch } from '@/components/react-icons/main';
import IconV2 from './v2/IconV2';
import RowV2 from './v2/RowV2';
import Input from './Input.jsx';

const SearchBar = ({ placeholder = 'Search', value, onSearch, autoFocus, delay = 50, icon, variant = 'header borderless', onKeyDown, debounce = true }) => {
  const [searchValue, setSearchValue] = useState(value);

  const handleDebounce = (value) => {
    onSearch(value);
  };

  const debouncedSearch = useDebounce(handleDebounce, delay, []);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    if (debounce) {
      debouncedSearch(e.target.value);
    } else {
      onSearch(e.target.value);
    }
  };

  useEffect(() => {
    if (value !== searchValue) {
      setSearchValue(value);
    }
  }, [value]);

  return (
    <RowV2 variant={variant} className="comp-search-bar" style={{ gap: 10 }}>
      {icon || icon === null ? icon : <IconV2 icon={FiSearch} title={'Search'} variant={'light'} />}
      <Input placeholder={placeholder} value={searchValue} onChange={handleSearchChange} autoFocus={autoFocus} className={'pane-option-list-search'} onKeyDown={onKeyDown} />
    </RowV2>
  );
};

export default SearchBar;
